// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TopBanner_wrapper_2VRP2","desktop":"TopBanner_desktop_3lcQ0"};